import axios from "axios";

const API = axios.create({
  // Importante: Usar https y verificar que no falte la 's'
  baseURL: "https://finsightgpt.com/api", 
  headers: { "Content-Type": "application/json" },
});

// Interceptor opcional para debugging rápido
API.interceptors.response.use(
  response => response,
  error => {
    console.error("Error en la petición API:", error.response || error.message);
    return Promise.reject(error);
  }
);

export const getCompanies = (orderBy = "valuation_desc") => API.get(`/financial/companies?orderBy=${orderBy}`);
export const chatConcepts = (payload) => API.post("/financial/concept", payload);
export const chatBudget = (payload) => API.post("/financial/chat", payload);

export default API;